import React from 'react';
import { styles } from './MenuDivider.css';

interface MenuDividerProps {
  isTopMenu?: boolean;
}

export const MenuDivider = ({ isTopMenu = false }: MenuDividerProps) => {
  return (
    <div className={styles.divider({ isTopMenu })}>
      <span className={styles.line} />
    </div>
  );
};
